module.exports = __webpack_public_path__ + "0c4d68d8af646fac41e149ec7b09c4b9.svg";